export default __webpack_public_path__ + "static/leadership-board-32c305022959241a45d95e83e1e4a985.png";